import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const EventSchedulerIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
    <path
      opacity="0.2"
      d="M4.375 9.625H23.625V5.25C23.625 5.01794 23.5328 4.79538 23.3687 4.63128C23.2046 4.46719 22.9821 4.375 22.75 4.375H5.25C5.01794 4.375 4.79538 4.46719 4.63128 4.63128C4.46719 4.79538 4.375 5.01794 4.375 5.25V9.625Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75065 1.45825C9.39498 1.45825 9.91732 1.98059 9.91732 2.62492V3.20825H18.084V2.62492C18.084 1.98059 18.6063 1.45825 19.2507 1.45825C19.895 1.45825 20.4173 1.98059 20.4173 2.62492V3.20825H22.7507C23.8782 3.20825 24.7923 4.12234 24.7923 5.24992V22.7499C24.7923 23.8775 23.8782 24.7916 22.7507 24.7916H5.25065C4.12307 24.7916 3.20898 23.8775 3.20898 22.7499V5.24992C3.20898 4.12234 4.12307 3.20825 5.25065 3.20825H7.58398V2.62492C7.58398 1.98059 8.10632 1.45825 8.75065 1.45825ZM7.58398 5.54158H5.54232V8.45825H22.459V5.54158H20.4173V6.12492C20.4173 6.76925 19.895 7.29158 19.2507 7.29158C18.6063 7.29158 18.084 6.76925 18.084 6.12492V5.54158H9.91732V6.12492C9.91732 6.76925 9.39498 7.29158 8.75065 7.29158C8.10632 7.29158 7.58398 6.76925 7.58398 6.12492V5.54158ZM22.459 10.7916H5.54232V22.4583H22.459V10.7916Z"
      fill="white"
    />
  </SvgIcon>
);

export default EventSchedulerIcon;
